// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { jettingAppResultStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppResult";
import IconTooltip from "@stoneage/XDL/Icons/IconTooltip";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppResultStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        ${({ bgColor }: any) =>
            bgColor &&
            `background-color: ${bgColor};
            `}

        ${({ hasMessage, borderColor }: any) => {
            if (hasMessage) {
                return css`
                    padding: 8px 12px;
                    margin: -8px -12px;
                    border-bottom: 1px solid ${borderColor};
                `;
            }
        }}
    `,
};

jettingAppResultStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 16px;
        align-items: center;
    `,
};

jettingAppResultStyles.label = {
    size: 14,
    weight: "bold",
    lineHeight: "16px",
    forwardAs: "p",
    css: css`
        width: auto;
        min-width: 140px;
        display: flex;
        
        ${({ shouldLabelTakeHalfWidth }: any) =>
            shouldLabelTakeHalfWidth &&
            `   width: 50%;
        `}
    `,
};
jettingAppResultStyles.messageWrapper = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: center;
    `,
};

jettingAppResultStyles.message = {
    size: 14,
    lineHeight: "16px",
    weight: "bold",
};

jettingAppResultStyles.value = {
    size: 14,
    lineHeight: "22px",
    forwardAs: "p",
    css: css``,
};

jettingAppResultStyles.tooltip = {
    iconProps: {
        src: IconTooltip,
        color: "primary.main",
        size: 14,
        css: css`
            margin-left: 4px;
            &: hover {
                opacity: 0.33;
            }
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            &[aria-expanded="true"] {
                ${IconWrapper} {
                    color: ${color("common.black")};
                }
            }
        `,
    },
};
